import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
export const usageTracker = createTracker({
  events
});
export const standaloneUsageTracker = createTracker({
  standalone: true,
  properties: {
    screen: 'customer-data-properties'
  }
});
export const trackSubmit = stageName => {
  usageTracker.track('revenuestagechangesubmit', {
    stageName
  });
};
export const trackConditionalPropertiesPanelSubmit = () => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    subscreen: `conditional-properties-panel`,
    action: 'submit'
  });
};
export const trackAutosaveSuccess = ({
  type,
  identifiers,
  objectTypeId
}) => {
  usageTracker.track('Interaction', Object.assign({
    screen: `customer-data-properties`,
    action: 'autosave success',
    type,
    objectTypeId
  }, type === 'PROPERTY' && {
    propertyNames: identifiers
  }, type === 'ASSOCIATION' && {
    associations: identifiers
  }));
};
export const trackAutosaveUndo = ({
  type,
  identifiers,
  objectTypeId
}) => {
  usageTracker.track('Interaction', Object.assign({
    screen: `customer-data-properties`,
    action: 'autosave undo',
    type
  }, type === 'PROPERTY' && {
    propertyNames: identifiers
  }, type === 'ASSOCIATION' && {
    associations: identifiers
  }, {
    objectTypeId
  }));
};
export const trackShowHighlySensitiveValueClick = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    propertyName,
    objectTypeId,
    action: 'show highly sensitive value'
  });
};
export const trackRejectedReviveDealSubmit = () => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    action: 'revive rejected deal'
  });
};
export const logPageView = payload => {
  usageTracker.track('Pageview', Object.assign({}, payload, {
    screen: `customer-data-properties`
  }));
};
export const trackExpandableTextCollapse = ({
  component,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    subscreen: component,
    action: 'expandable text collapse',
    propertyName,
    objectTypeId
  });
};
export const trackExpandableTextExpand = ({
  component,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    subscreen: component,
    action: 'expandable text expand',
    propertyName,
    objectTypeId
  });
};
export const trackDetailsLinkButtonClick = ({
  propertyName,
  objectTypeId,
  type
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    action: 'details link button click',
    type,
    propertyName,
    objectTypeId
  });
};
export const trackFormattedPropertyPhoneClick = () => {
  usageTracker.track('Interaction', {
    screen: 'customer-data-properties',
    action: 'initiate call'
  });
};